export interface AuctionMessage {
  from_email: string;
  from_display_name: string;
  to_bid_id: string;
  text: string;
}
